import React, { useEffect, useRef, useState } from "react";
import { CheckIcon, CopyIcon } from "./TriloChatIcons";
import { copyResponse } from "../utils/triloChatCopy";

const COPIED_RESET_MS = 2000;

/**
 * TriloChatCopyButton
 *
 * Icon button that copies text as rich text (see utils/triloChatCopy.js) and
 * briefly shows a tick. By default it sits in the top-right corner of an
 * assistant bubble; `inline` lets it flow in a header row instead.
 *
 * Props:
 * - content: Raw Markdown text to copy
 * - label: Tooltip / accessible name (default "Copy response")
 * - inline: Render in the normal flow rather than absolutely positioned
 */
const TriloChatCopyButton = ({
  content,
  label: idleLabel = "Copy response",
  inline = false,
}) => {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef(null);

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const handleCopy = async () => {
    if (!(await copyResponse(content))) return;
    setCopied(true);
    clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => setCopied(false), COPIED_RESET_MS);
  };

  const label = copied ? "Copied" : idleLabel;
  return (
    <button
      type="button"
      className={`trilochat__copy-btn${inline ? " trilochat__copy-btn--inline" : ""}${copied ? " trilochat__copy-btn--copied" : ""}`}
      title={label}
      aria-label={label}
      onClick={handleCopy}>
      {copied ? <CheckIcon /> : <CopyIcon />}
    </button>
  );
};

export default TriloChatCopyButton;
